import CurrencyCell from "../components/CurrencyCell";
import DiscountCell from "../components/DiscountCell";
import PercentageCell from "../components/PercentageCell";
import { daysInCurrentMonth } from "../helpers";
import CustomButtonComponent from "./CustomButtonComponent";

const schemeColDef = [
  {
    headerName: "",
    headerClass: "primary",
    children: [
      {
        headerClass: "primary",
        field: "Region",
        width: 130,
        editable: true,
        pinned: true,
        filter: "text",
      },
      {
        headerClass: "primary",
        field: "Country",
        width: 130,
        editable: true,
        pinned: true,
        filter: "text",
      },

      {
        headerClass: "primary",
        field: "Warehouse",
        width: 130,
        editable: true,
        pinned: true,
        filter: "text",
      },
  {
    headerClass: "primary",
    headerName: "Channel",
    field: "Channel",
    width: 120,
    pinned: true,
    filter: "text",
  },
  {
    headerClass: "primary",
    headerName: "Pricelist",
    field: "Pricelist",
    width: 120,
    aggFunc: "sum",
    pinned: true,
    filter: "text",
  },
  {
    headerClass: "primary",
    headerName: "Product ",
    field: "Product_Name",
    width: 120,
    aggFunc: "sum",
    pinned: true,
    filter: "text",
  },
  {
    headerClass: "primary",
    headerName: "Start Date",
    field: "SchemeStartDate",
    width: 120,
    editable: true,
    filter: "text",
  },

  {
    headerClass: "primary",
    headerName: "End Date",
    field: "SchemeEndDate",
    width: 175,
    filter: "text",
  },

  {
    headerClass: "primary",
    headerName: "Name",
    field: "Scheme_Name",
    width: 120,
    aggFunc: "sum",
    filter: "text",
  },

  {
    headerClass: "primary",
    headerName: "Type",
    field: "Scheme_Type",
    width: 120,
    aggFunc: "sum",
    filter: "text",
  },
]
  },
  {
    headerName: "Qty",
    headerClass: "primary",
    children: [
      {
        headerClass: "primary",
        headerName: "Baseline",
        field: "Baseline_Qty",
        width: 120,
        aggFunc: "sum",
        type: "rightAligned",
        // cellRenderer: CurrencyCell,
      },
      {
        headerClass: "primary",
        headerName: "Impact %",
        field: "Qty_Impact",
        width: 120,
        aggFunc: "sum",
        cellRenderer: PercentageCell,
        type: "rightAligned",
        // cellRenderer: CurrencyCell,
      },
      {
        headerClass: "primary",
        headerName: "Value",
        field: "Qty_Impact_Value",
        width: 120,
        aggFunc: "sum",
        type: "rightAligned",
        // cellRenderer: CurrencyCell,
      },
    ],
  },

  {
    headerName: "Rate",
    headerClass: "primary",
    children: [
      {
        headerClass: "primary",
        headerName: "Baseline",
        field: "Rate_Baseline",
        width: 120,
        aggFunc: "sum",
        type: "rightAligned",
        //cellRenderer: DiscountCell,
      },

      {
        headerClass: "primary",
        headerName: "Impact %",
        field: "Rate_Impact",
        width: 120,
        aggFunc: "sum",
        cellRenderer: PercentageCell,
        type: "rightAligned",
      },

      {
        headerClass: "primary",
        headerName: "Value",
        field: "Rate_Impact_Value",
        width: 120,
        aggFunc: "sum",
        cellRenderer: DiscountCell,
        type: "rightAligned",
      },

    ]},

    {
      headerName: "Revenue",
      headerClass: "primary",
      children: [
        {
          headerClass: "primary",
          headerName: "Baseline",
          field: "Revenue_Baseline",
          width: 120,
          aggFunc: "sum",
          cellRenderer: DiscountCell,
          type: "rightAligned",
        },
  
        {
          headerClass: "primary",
          headerName: "Impact %",
          field: "Revenue_Impact",
          width: 120,
          aggFunc: "sum",
          cellRenderer: PercentageCell,
          type: "rightAligned",
        },
  
        {
          headerClass: "primary",
          headerName: "Value",
          field: "Revenue_Impact_Value",
          width: 120,
          aggFunc: "sum",
          cellRenderer: DiscountCell,
          type: "rightAligned",
        },
  
      ]},

      {
        headerName: "Actual",
        headerClass: "primary",
        children: [
          {
            headerClass: "primary",
            headerName: "Qty",
            field: "Actual_Qty",
            width: 120,
            aggFunc: "sum",
            cellRenderer: DiscountCell,
            type: "rightAligned",
          },
    
          {
            headerClass: "primary",
            headerName: "Rate",
            field: "Actual_Rate",
            width: 120,
            aggFunc: "sum",
            cellRenderer: DiscountCell,
            type: "rightAligned",
          },
    
          {
            headerClass: "primary",
            headerName: "Val",
            field: "Actual_Value",
            width: 120,
            aggFunc: "sum",
            cellRenderer: DiscountCell,
            type: "rightAligned",
          },
    
        ]},

  // {
  //   headerClass: "primary",
  //   headerName: "Rate Impact Value",
  //   field: "Sales",
  //   width: 120,
  //   aggFunc: "sum",
  //   cellRenderer: DiscountCell,
  // },

  // {
  //   headerClass: "primary",
  //   headerName: "Rate Impact %22",
  //   field: "Rate_Impact",
  //   width: 120,
  //   aggFunc: "sum",
  //   cellRenderer: PercentageCell,
  // },
  // {
  //   headerClass: "primary",
  //   headerName: "Quantity Impact %",
  //   field: "Qty_Impact",
  //   width: 120,
  //   aggFunc: "sum",
  //   cellRenderer: PercentageCell,
  // },
  {
    headerName: "",
    headerClass: "primary",
    children: [
  {
    headerClass: "primary",
    headerName: "Actions",
    field: "actions",
    width: 250,
    cellRenderer: CustomButtonComponent,
    aggFunc: "sum",
  },
]},
];

export { schemeColDef };
